<template>
  <div class="flex flex-col items-center gap-3">
    <!-- User Avatars -->
    <div class="flex items-center -space-x-3">
      <img
        v-for="(user, index) in users"
        :key="index"
        :src="user"
        :alt="`User ${index + 1}`"
        class="w-10 h-10 rounded-full border-2 border-white shadow-md object-cover"
        :style="{ zIndex: users.length - index }"
      />
    </div>
    
    <!-- Social Proof Text -->
    <p class="text-sm font-medium text-gray-700">
      Loved by <span class="font-bold text-primary">thousands of users</span>
    </p>
  </div>
</template>

<script>
export default {
  name: 'SocialProof',
  data() {
    return {
      users: [
        require('@/assets/user_2.webp'),
        require('@/assets/user_4.webp'),
        require('@/assets/user_3.webp'),
        require('@/assets/user_7.webp'),
        require('@/assets/user_5.webp')
      ]
    };
  }
};
</script>

<style scoped>
img {
  transition: transform 0.2s ease;
}

img:hover {
  transform: scale(1.1);
  z-index: 999 !important;
}
</style>
